import { render } from "./SearchComponent.vue?vue&type=template&id=ce87f49c"
import script from "./SearchComponent.vue?vue&type=script&lang=js"
export * from "./SearchComponent.vue?vue&type=script&lang=js"

import "./SearchComponent.vue?vue&type=style&index=0&id=ce87f49c&lang=css"
script.render = render

export default script